export default __webpack_public_path__ + "static/media/shirt.59ce310c.png";